import React, { useEffect, useState } from "react";
import { __ } from "services/Translator";

/**
 * Collapsible filter block for Transaction / Gaming history (saves mobile viewport).
 */
export default function HistoryFiltersPanel({
  summary = "",
  isMobileDevice,
  onSearch,
  onReset,
  children,
}) {
  const [expanded, setExpanded] = useState(!isMobileDevice);

  useEffect(() => {
    setExpanded(!isMobileDevice);
  }, [isMobileDevice]);

  const handleSearch = () => {
    onSearch?.();
    if (isMobileDevice) {
      setExpanded(false);
    }
  };

  const handleReset = () => {
    onReset?.();
  };

  if (!isMobileDevice) {
    return (
      <div className="history-filters">
        <div className="row history-filters__row">
          {children}
          <div className="col-12 history-filters__actions-col">
            <div className="button_group history-filters__actions">
              <button type="button" onClick={handleSearch} className="commonBtn pTwoBtn">
                {__("Search")}
              </button>
              <button
                type="button"
                onClick={handleReset}
                className="commonBtn pTwoBtn history-filters__btn-reset"
              >
                {__("Reset")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={
        "history-filters history-filters--mobile" +
        (expanded ? " history-filters--expanded" : "")
      }
    >
      <button
        type="button"
        className="history-filters__toggle"
        onClick={() => setExpanded((open) => !open)}
        aria-expanded={expanded}
      >
        <span className="history-filters__toggle-content">
          <span className="history-filters__toggle-main">
            <i className="fas fa-sliders-h history-filters__toggle-icon" aria-hidden="true" />
            <span className="history-filters__toggle-label">{__("Filters")}</span>
          </span>
          {summary ? (
            <span className="history-filters__toggle-summary">{summary}</span>
          ) : null}
        </span>
        <i
          className={
            "fas history-filters__chevron " +
            (expanded ? "fa-chevron-up" : "fa-chevron-down")
          }
          aria-hidden="true"
        />
      </button>

      {expanded ? (
        <div className="history-filters__panel">
          <div className="row history-filters__row history-filters__row--mobile">
            {children}
          </div>
          <div className="history-filters__actions-col">
            <div className="button_group history-filters__actions">
              <button type="button" onClick={handleSearch} className="commonBtn pTwoBtn">
                {__("Search")}
              </button>
              <button
                type="button"
                onClick={handleReset}
                className="commonBtn pTwoBtn history-filters__btn-reset"
              >
                {__("Reset")}
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
